import useLayerListeners from './useLayerListeners';
import mapValues from 'lodash/mapValues';
import omit from 'lodash/omit';
import { Ref, WatchStopHandle } from 'vue';
import { LAYER_CONFIG_OMIT_PROP } from '../constants';

export default function usePolygonLayer(mapInstance: LooseObject, layerInfo: Ref<MapLayer<PolygonLayerConfig>>) {
  if (!layerInfo.value || !layerInfo.value.config) return;

  const { id: layerId } = layerInfo.value;

  let polygonStyle;
  let geometries: PolygonGeometry[];
  let unwatchList: WatchStopHandle[] | null = [];

  const polygonLayer = new TMap.MultiPolygon({
    id: layerId,
    map: mapInstance,
  });

  unwatchList.push(watchEffect(() => {
    const styleConfig = omit(layerInfo.value.config, LAYER_CONFIG_OMIT_PROP);
    const styleOption = mapValues(styleConfig, val => toRaw(unref(val)));
    polygonStyle = new TMap.PolygonStyle(styleOption);
    if (polygonLayer) polygonLayer.setStyles({ polygonStyle });
  }));

  unwatchList.push(watchEffect(() => {
    if (!Array.isArray(layerInfo.value.config.data)) return;
    try {
      geometries = layerInfo.value.config.data.map((geometry: PolygonGeometry, index: number) => {
        const { id, paths, rank, properties } = geometry;
        const polygonGeometriesList: PolygonGeometry['paths'] = [];
        paths.forEach((item) => {
          if (!Array.isArray(item)) {
            polygonGeometriesList.push(new TMap.LatLng(item.lat, item.lng));
          } else {
            const polygonGeometriesChild: PolygonGeometry['paths'] = [];
            item.forEach((itemChild) => {
              if (!Array.isArray(itemChild)) {
                polygonGeometriesChild.push(new TMap.LatLng(itemChild.lat, itemChild.lng));
              } else {
                polygonGeometriesChild.push(itemChild.map(child => new TMap.LatLng(child.lat, child.lng)));
              }
            });
            // todo ts
            polygonGeometriesList.push(polygonGeometriesChild);
          }
        });

        return {
          id: id ? id : `${index}`,
          paths: polygonGeometriesList,
          rank: rank ? rank : index,
          styleId: 'polygonStyle',
          properties,
        };
      });
      if (polygonLayer) polygonLayer.setGeometries(geometries);
    } catch (error) {
      polygonLayer?.setGeometries([]);
    }
  }));

  // 针对配置的改变，重建图层
  // watch(() => layerInfo.config, () => {
  //   polygonLayer.destroy();
  //   polygonLayer = null;
  //   usePolygonLayer(mapInstance, layerInfo);
  // });

  unwatchList.push(watchEffect(() => {
    useLayerListeners(polygonLayer, [
      { eventName: 'click', callbackList: layerInfo.value.config.onClick },
      { eventName: 'hover', callbackList: layerInfo.value.config.onHover },
    ]);
  }));

  polygonLayer.unmount = (): void => {
    polygonLayer?.destroy();
    unwatchList?.forEach(unwatch => unwatch());
    unwatchList = null;
  };

  return polygonLayer;
}
